import React, { useEffect, useState } from "react";
import Content from "../../../components/Contents/Content";
import { clientKycAndAgreement, GetUserData, GetPanverify } from "../../../Services/UserService/User";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";
import { redirect } from "react-router-dom";
import { base_url, base_urlfrontend } from "../../../../Utils/config";
import { basicsettinglist } from "../../../Services/Admin/Admin";

function Kyc({ onSuccess, setViewModel3, setViewModel2, type, kyckey }) {



  const userid = localStorage.getItem("id");
  const token = localStorage.getItem('token');
  const [loading, setLoading] = useState(false);
  const [panVerifyLoading, setPanVerifyLoading] = useState(false);
  const [krastatus, setKrastatus] = useState({})
  const [verfystatus, setVerfiystatus] = useState(0)
  const [isChangedAfterVerify, setIsChangedAfterVerify] = useState(false);



  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    aadhar: "",
    panno: "",
  });

  const [touched, setTouched] = useState({
    fullName: false,
    email: false,
    phone: false,
    aadhar: false,
    panno: false,
  });

  const [errors, setErrors] = useState({
    fullName: "",
    email: "",
    phone: "",
    aadhar: "",
    panno: "",
  });

  const fetchUserData = async () => {
    try {
      const userData = await GetUserData(userid, token);

      if (userData && userData.data) {
        const user = userData.data;
        setVerfiystatus(user?.kraapi_status)
        setFormData({
          fullName: user.FullName || "",
          email: user.Email || "",
          phone: user.PhoneNo || "",
          aadhar: "",
          panno: user.panno || "",
        });
      }
    } catch (error) {
      console.error("Failed to fetch user data:", error);
      showCustomAlert("error", "Failed to load user data. Please refresh and try again.");
    }
  };

  const getkeybydata = async () => {
    try {
      const response = await basicsettinglist();
      if (response.status) {
        setKrastatus(response.data[0]?.kra_status)
      }
    } catch (error) {
      console.error("Error fetching coupons:", error);
    }
  };

  const Verfiypancarddata = async () => {
    if (!formData.panno) {
      showCustomAlert("error", "Please enter PAN number");
      return;
    }

    if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.panno)) {
      showCustomAlert("error", "Please enter a valid PAN number in correct format (e.g., ABCDE1234F)");
      return;
    }

    setPanVerifyLoading(true);

    try {
      const data = { clientid: userid, pan: formData.panno }
      const response = await GetPanverify(data);

      if (response.success) {
        setVerfiystatus(1);
        showCustomAlert("success", response.message);

        setErrors(prev => ({
          ...prev,
          panno: "",
        }));
      } else {
        showCustomAlert("error", response.message);
        setVerfiystatus(0);
      }
    } catch (error) {
      console.error("Error verifying PAN:", error);
      showCustomAlert("error", "KRA settings are not configured properly");
      setVerfiystatus(0);
    } finally {
      setPanVerifyLoading(false);
    }
  };

  useEffect(() => {
    if (Number(verfystatus) === 1) {
      setErrors((prev) => ({
        ...prev,
        panno: "",
      }));
    }
  }, [verfystatus]);

  useEffect(() => {
    if (userid) {
      getkeybydata()
      fetchUserData();
    }
  }, [userid]);




  const validateField = (name, value) => {
    let errorMessage = "";

    switch (name) {
      case "fullName":
        if (!value.trim()) {
          errorMessage = "Name is required";
        } else if (value.trim().length < 3) {
          errorMessage = "Name must be at least 3 characters";
        } else if (!/^[A-Za-z\s]+$/.test(value)) {
          errorMessage = "Name should contain only letters and spaces";
        }
        break;

      case "email":
        if (!value) {
          errorMessage = "Email is required";
        } else if (!/^\S+@\S+\.\S+$/.test(value)) {
          errorMessage = "Please enter a valid email address";
        }
        break;

      case "phone":
        if (!value) {
          errorMessage = "Phone number is required";
        } else if (!/^[6-9]\d{9}$/.test(value)) {
          errorMessage = "Please enter a valid 10-digit Indian mobile number";
        }
        break;

      case "aadhar":
        if (!value) {
          errorMessage = "Aadhar number is required";
        } else if (!/^\d{12}$/.test(value)) {
          errorMessage = "Aadhar number must be 12 digits";
        }
        break;

      case "panno":
        if (!value) {
          errorMessage = "PAN number is required";
        } else if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(value)) {
          errorMessage = "PAN must be in Capital format (e.g., ABCDE1234F)";
        } else if (verfystatus === 0 && krastatus === 1) {
          errorMessage = "Please Verify the PAN Card";
        }
        break;
      default:
        break;
    }

    return errorMessage;
  };




  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });

    if (touched[name]) {
      const errorMessage = validateField(name, value);
      setErrors(prev => ({
        ...prev,
        [name]: errorMessage
      }));
    }
  };





  const handleBlur = (e) => {
    const { name, value } = e.target;

    setTouched(prev => ({
      ...prev,
      [name]: true
    }));

    const errorMessage = validateField(name, value);
    setErrors(prev => ({
      ...prev,
      [name]: errorMessage
    }));
  };

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    const newTouched = {};

    Object.keys(formData).forEach(key => {
      newTouched[key] = true;
      const errorMessage = validateField(key, formData[key]);
      newErrors[key] = errorMessage;
      if (errorMessage) {
        isValid = false;
      }
    });

    setTouched(newTouched);
    setErrors(newErrors);
    return isValid;
  };

  const handleKycSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      showCustomAlert("error", "Please fix the errors in the form");
      return;
    }

    setLoading(true);

    try {
      const data = new FormData();
      data.append('email', formData.email);
      data.append('name', formData.fullName);
      data.append('phone', formData.phone);
      data.append('panno', formData.panno);
      data.append('aadharno', formData.aadhar);
      data.append('id', userid);

      const result = await clientKycAndAgreement(data, token);

      if (result.customer_identifier) {
        setFormData({
          aadhar: "",
          panno: "",
        });

        setTouched({
          fullName: false,
          email: false,
          phone: false,
          aadhar: false,
          panno: false,
        });

        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess();
        }

        // window.open(
        //   encodeURI(`https://app.digio.in/#/gateway/login/${result?.kid}/${result?.refid}/${result?.customer_identifier}?redirect_url=${base_url}api/client/uploaddocuments?id=${userid}&type=${type}&planid=${kyckey}`),
        //   '_blank'
        // );

        const encodedRedirectUrl = encodeURIComponent(
          `${base_url}api/client/uploaddocuments?id=${userid}&type=${type}&planid=${kyckey}`
        );
        const fullURL = `https://app.digio.in/#/gateway/login/${result?.kid}/${result?.refid}/${result?.customer_identifier}?redirect_url=${encodedRedirectUrl}`;
        window.open(fullURL, '_blank');


      } else {
        showCustomAlert("error", result.message);
      }
    } catch (err) {
      console.error('KYC Failed:', err);
      showCustomAlert("error", err.message);
    }

    setLoading(false);
  };

  return (
    <div className="container mt-4">
      <div className="card shadow">
        <div className="card-body">
          <form onSubmit={handleKycSubmit}>
            <div className="mb-3 row">
              <div className="col-md-6">
                <label htmlFor="fullName" className="form-label text-white">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="fullName"
                  name="fullName"
                  placeholder="Enter your full name"
                  value={formData.fullName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                />
                {touched.fullName && errors.fullName && (
                  <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                    {errors.fullName}
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <label htmlFor="email" className="form-label text-white">
                  Email
                </label>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  name="email"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  disabled
                />
                {touched.email && errors.email && (
                  <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                    {errors.email}
                  </div>
                )}
              </div>

              <div className="col-md-6">
                <label htmlFor="phone" className="form-label text-white">
                  Mobile No.
                </label>
                <input
                  type="tel"
                  className="form-control"
                  id="phone"
                  name="phone"
                  placeholder="Enter your 10-digit mobile number"
                  value={formData.phone}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength="10"
                  disabled
                />
                {touched.phone && errors.phone && (
                  <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                    {errors.phone}
                  </div>
                )}
              </div>

              <div className="mb-3 col-md-6">
                <label htmlFor="aadhar" className="form-label text-white">
                  Aadhar No.
                </label>
                <input
                  type="number"
                  className="form-control"
                  id="aadhar"
                  name="aadhar"
                  placeholder="Enter your 12-digit Aadhar number"
                  value={formData.aadhar}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  maxLength="12"
                />
                {touched.aadhar && errors.aadhar && (
                  <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                    {errors.aadhar}
                  </div>
                )}
              </div>

              <div className="mb-3 col-md-6">
                <label htmlFor="panno" className="form-label text-white">
                  PAN No.
                </label>
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    id="panno"
                    name="panno"
                    placeholder="Enter your PAN (e.g., ABCDE1234F)"
                    disabled={verfystatus === 1}
                    value={formData.panno}
                    onChange={(e) => {
                      const upperCaseValue = e.target.value.toUpperCase();
                      handleChange({
                        target: {
                          name: e.target.name,
                          value: upperCaseValue,
                        },
                      });
                      if (verfystatus === 1) {
                        setIsChangedAfterVerify(true);
                        setVerfiystatus(0);
                      }
                    }}
                    onBlur={handleBlur}
                    maxLength="10"
                  />
                  {/* <button
                    type="button"
                    className="btn btn-outline-success"
                    onClick={Verfiypancarddata}
                    disabled={verfystatus === 1 || panVerifyLoading}
                  >
                    {panVerifyLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                        Verifying...
                      </>
                    ) : (
                      verfystatus === 0 ? "Verify" : "Verified"
                    )}
                  </button> */}

                  {/* {verfystatus === 1 && (
                    <button
                      className="btn btn-outline-warning ms-2"
                      type="button"
                      onClick={() => {
                        setIsChangedAfterVerify(false);
                        setVerfiystatus(0);
                      }}
                    >
                      Change
                    </button>
                  )} */}
                </div>

                {touched.panno && errors.panno && (
                  <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
                    {errors.panno}
                  </div>
                )}
              </div>
            </div>

            <div className="w-auto">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Submitting...
                  </>
                ) : (
                  "Submit"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Kyc;